import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import { buildValidationRules } from '../utils/fieldUtils'
import SydTimeInput from './components/SydTimeInput'

function TimeFieldEditor ({ field, control, form }) {
  const baseRules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  // Add time validation
  const rules = {
    ...baseRules,
    validate: {
      ...(baseRules.validate || {}),
      validTime: (value) => {
        if (!value || value === '') return true
        // Check if value is in HH:mm or HH:mm:ss format
        const timeRegex = /^\d{2}:\d{2}(:\d{2})?$/
        if (!timeRegex.test(value)) {
          return 'Invalid time format.'
        }
        return true
      }
    }
  }

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydTimeInput
            {...hookField}
          />
        </SydLabel>
      )}
    />
  )
}

TimeFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default TimeFieldEditor
